import React from 'react'

function Line(props) {
  const {
    direction = 'row',
    color = '#018AD1',
    width = 100,
    style = {}
  } = props

  const widthStyle = {
    row: { width: width, height: '2px' },
    col: { height: width, width: '2px' }
  }

  return (
    <div
      // className={styles[getStyle(direction)]}
      style={{
        background: color,
        ...widthStyle[direction],
        ...style
      }}
    />
  )
}

export default Line
